import React from 'react';
import PropTypes from 'prop-types';
import { defaultTemplate } from 'core/hoc';
import { BasicFieldCheckbox, BasicInput, BasicTextArea, BaasicFieldDropdown } from 'core/components';
import { ApplicationEditLayout, Content } from 'core/layouts';

function ImportReferenceEditTemplate({ editView }) {
    const {
        contentLoading,
        form,
        insuranceStore,
        importReferenceTypeStore
    } = editView;

    return (
        <ApplicationEditLayout store={editView}>
            <Content loading={contentLoading} >
                <div className="row">
                    <div className="col col-sml-12 col-lrg-8">
                        <div className="card card--form card--primary card--med">
                            <div>
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <BasicInput field={form.$('name')} />
                                </div>
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <BaasicFieldDropdown allowEmpty={true} field={form.$('insuranceId')} store={insuranceStore} disabled={false}/>
                                </div>
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <BaasicFieldDropdown allowEmpty={true} field={form.$('importReferenceTypeId')} store={importReferenceTypeStore} disabled={false}/>
                                </div>
                                <div className="form__group col col-lrg-12 u-mar--bottom--sml">
                                    <BasicTextArea field={form.$('description')} />
                                </div>
                                   
                                    <div className="form__group col col-lrg-12  u-mar--bottom--sml">
                                        <BasicFieldCheckbox className="has-fake-label"  field={form.$('isBillableToMedicare')} /><span className="fake-label">Is Billable To Insurance</span>
                                    </div>
                                    <div className="form__group col col-lrg-12  u-mar--bottom--sml">
                                        <BasicFieldCheckbox  className="has-fake-label"  field={form.$('isActive')} /><span className="fake-label u-mar--bottom--sml">Is Active</span>
                                    </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Content>
        </ApplicationEditLayout>
    )
}

ImportReferenceEditTemplate.propTypes = {
    editView: PropTypes.object
};

export default defaultTemplate(ImportReferenceEditTemplate);
